import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/manager';
const find = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/reservationSettings`
		),
		{
			branchId,
		}
	);
};

const create = (systemSource, merchantId, payload) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/reservationSettings`
		),
		payload
	);
};

const update = (systemSource, merchantId, id, payload) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/reservationSettings/${id}`
		),
		payload
	);
};

export default {
	find,
	create,
	update,
};
